import _isEmpty from 'lodash/isEmpty';
import _assign from 'lodash/assign';

import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.sections, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_SECTIONS}_SUCCESS`: {
      let sections = action.payload;
      if (_isEmpty(sections))
        sections = {
          sectionsNotGrouped: [],
          forSolutionPage: [],
        };
      const { sectionsNotGrouped, forSolutionPage } = sections;
      return _assign({}, sections, {
        sectionsNotGrouped,
        forSolutionPage,
      });
    }

    // added this because of contradictory , solution get cleared from SOLUTIONS key in reducer but not cleared from sectionsNotGrouped[section].[problem].
    case `${ActionTypes.REMOVE_PROBLEM_SOLUTION}`: {
      const { problemSlug, clusterSlug } = action;
      const newState = { ...state };

      newState.sectionsNotGrouped.forEach((section, sectionIndex) => {
        section.problems.forEach((problem, problemIndex) => {
          if (clusterSlug && problem.children) {
            if (problem.slug === clusterSlug) {
              problem.children.forEach((subProblem, subProblemIndex) => {
                if (subProblem.slug === problemSlug) {
                  newState.sectionsNotGrouped[sectionIndex].problems[
                    problemIndex
                  ].children[subProblemIndex].solution = null;
                }
              });
            }
          } else if (problem.slug === problemSlug) {
            newState.sectionsNotGrouped[sectionIndex].problems[
              problemIndex
            ].solution = null;
          }
        });
      });

      return newState;
    }
    default:
      return state;
  }
};
